import { Box, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';

export default function PublicDsrJoinRoomLoginForm({
	handleLoginJoinRoom,
	processedEmailAddress,
	loginPasswordInput,
	onChangeHandler,
	showPasswordError,
	showIncorrectPasswordError,
	greetingName,
	isProcessing
}) {
	const welcomeMessage = greetingName ? `Welcome back, ${greetingName}` : 'Welcome back';

	return (
		<Box w='100%' mt='1em'>
			<Box fontSize='1em' color='brandDark.500' fontWeight='600' textAlign='center'>
				{welcomeMessage}
			</Box>

			<Box fontSize='0.875em' color='gray.500' fontWeight='500' mt='0.25em' textAlign='center'>
				Log in to enter the room
			</Box>

			<Box w="100%" align="center" mt='1em'>
				<Flex direction='column' gap='1em' maxW='22.5em' w='100%' my='2em'>

					<LaunchdeckFormInput
						label='Email'
						placeholder={processedEmailAddress}
						isDisabled={true}

					/>

					<LaunchdeckFormInput
						label='Password'
						name={'login-password-input'}
						onChange={onChangeHandler}
						value={loginPasswordInput}
						isRequired={true}
						isDisabled={isProcessing}
						type='password'

						errorLogic={showPasswordError}
						errorMessage={'The password is too short. Please check and try again.'}
					/>

					<WarningTextMessage errorLogic={showIncorrectPasswordError} message='We are unable to authenticate your login with this password' />

					<Flex w='100%' mt='1em' >
						<Flex justify='flex-end' w='100%'>
							<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Log in' loadingLogic={isProcessing} onClick={() => handleLoginJoinRoom()} />
						</Flex>
					</Flex>

					{showIncorrectPasswordError &&
						<Link to="/reset-password">
							<Flex w='100%'>
								<LaunchdeckButton bg='gray.500' color='white' w='100%' label='Forget password' />
							</Flex>
						</Link>
					}
				</Flex>
			</Box>
		</Box>

	);
};


